"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecoratorMetadataStorage = exports.DecoratorMetadataStorage = void 0;
var decoratorMetadataStorage;
var DecoratorMetadataStorage = /** @class */ (function () {
    function DecoratorMetadataStorage() {
        this.commonServices = new Map();
    }
    DecoratorMetadataStorage.prototype.getCommonService = function (serviceAlias) {
        return this.commonServices.get(serviceAlias);
    };
    DecoratorMetadataStorage.prototype.findCommonServicesByAngularServiceName = function (angularServiceName) {
        var services = [];
        this.commonServices.forEach(function (commonService) {
            var _a, _b;
            var index = (_b = (_a = commonService.options) === null || _a === void 0 ? void 0 : _a.replaceAngularService) === null || _b === void 0 ? void 0 : _b.indexOf(angularServiceName);
            if (index !== undefined && index >= 0) {
                services.push(commonService);
            }
        });
        return services;
    };
    DecoratorMetadataStorage.prototype.setCommonService = function (serviceAlias, metadata) {
        this.commonServices.set(serviceAlias, metadata);
    };
    return DecoratorMetadataStorage;
}());
exports.DecoratorMetadataStorage = DecoratorMetadataStorage;
function getDecoratorMetadataStorage() {
    if (!decoratorMetadataStorage) {
        decoratorMetadataStorage = new DecoratorMetadataStorage();
    }
    return decoratorMetadataStorage;
}
exports.getDecoratorMetadataStorage = getDecoratorMetadataStorage;
//# sourceMappingURL=DecoratorMetadataStorage.js.map